/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* FSx backup information
*/
export class FsxBackupData {
  /**
  * The unique identifier of the FSx backup
  */
  'backupId'?: string;
  /**
  * The AWS region where the backup is located
  */
  'region'?: string;
  /**
  * The time when the backup was created
  */
  'creationTime'?: Date;
  /**
  * The lifecycle status of the backup (e.g., AVAILABLE, CREATING, DELETED)
  */
  'lifecycle'?: string;
  /**
  * The type of the backup (e.g., USER_INITIATED, AUTOMATIC)
  */
  'type'?: string;
  /**
  * The size of the backup in bytes
  */
  'size'?: number;
  /**
  * Tags associated with the backup
  */
  'tags'?: { [key: string]: string; };
  /**
  * The resource type that\'s backed up (FILE_SYSTEM or VOLUME)
  */
  'resourceType'?: string;
  /**
  * The KMS key ID used to encrypt the backup
  */
  'kmsKeyId'?: string;
  /**
  * The AWS account ID that owns the backup
  */
  'ownerId'?: string;
  /**
  * The ARN of the backup resource
  */
  'resourceArn'?: string;
  /**
  * Progress percentage for async operations
  */
  'progressPercent'?: number;
  /**
  * Source backup ID if this backup was copied
  */
  'sourceBackupId'?: string;
  /**
  * Source region if this backup was copied
  */
  'sourceBackupRegion'?: string;
  /**
  * Failure details if the backup failed
  */
  'failureMessage'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupId",
      "baseName": "backupId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lifecycle",
      "baseName": "lifecycle",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "size",
      "baseName": "size",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "string",
      "format": ""
    },
    {
      "name": "kmsKeyId",
      "baseName": "kmsKeyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "ownerId",
      "baseName": "ownerId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceArn",
      "baseName": "resourceArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "progressPercent",
      "baseName": "progressPercent",
      "type": "number",
      "format": ""
    },
    {
      "name": "sourceBackupId",
      "baseName": "sourceBackupId",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceBackupRegion",
      "baseName": "sourceBackupRegion",
      "type": "string",
      "format": ""
    },
    {
      "name": "failureMessage",
      "baseName": "failureMessage",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FsxBackupData.attributeTypeMap;
  }

  public constructor() {
  }
}

